const CONSENT_KEY = "proshare_tracking_consent";
const SESSION_DISMISS_KEY = "proshare_tracking_consent_dismissed";

export const getTrackingConsent = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CONSENT_KEY) === "true";
};

export const setTrackingConsent = (granted) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CONSENT_KEY, granted ? "true" : "false");
  window.dispatchEvent(
    new CustomEvent("proshare:tracking-consent-changed", {
      detail: { granted: Boolean(granted) },
    })
  );
};

export const hasStoredTrackingConsent = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CONSENT_KEY) !== null;
};

export const dismissTrackingConsentForSession = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(SESSION_DISMISS_KEY, "true");
};

export const hasDismissedTrackingConsentForSession = () => {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(SESSION_DISMISS_KEY) === "true";
};

export const clearTrackingConsentSessionDismissal = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(SESSION_DISMISS_KEY);
};
